module.exports = __webpack_public_path__ + "static/graphicElementsNo-64d019b6c0372e346ca7410417fbb2e1.png";